import React from 'react'
import PropTypes from 'prop-types'

import { bgImage } from '../../../utils'

/**
 * A component to render div w/ background image & img element for screen readers
 *
 * @param {string} props.src - Optional paragraph heading
 * @param {string} props.alt - Enum: 'regular' | 'large' | 'image'
 * @param {string} props.imagePosition - Image position puts in backgroundPositionY. top, center, bottom
 * @param {string} props.className - class name
 * @param {node | element} props.children - DOM elements or JSX expressions
 * @param {any} props.rest - Used to add e.g. inline style, key
 *
 * @returns {JSX.Element} Renders paragraph with correct layout & content
 */

const ImageDiv = ({
  src,
  alt,
  imagePosition,
  className,
  children,
  ...rest
}) => {
  return (
    <div
      style={{ ...bgImage(src), backgroundPositionY: imagePosition }}
      className={className}
      {...rest}
    >
      <img alt={alt} src={src} className="sr-only" />
      {children}
    </div>
  )
}

ImageDiv.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  chidren: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  rest: PropTypes.any,
}

export default ImageDiv
